import { gql } from "@apollo/client";

export const GET_ALL_CATEGORIES = gql`
  query getAllCategories($lang: Langs!, $type: ListingCategoryType) {
    Web {
      categories(lang: $lang, type: $type) {
        name
        plural
        uri
        path
        keywords
        id
      }
    }
  }
`;

export const getCachedCategory = (client, uri) => {
  return client.readFragment({
    id: `Category:${JSON.stringify({ uri })}`,
    fragment: gql`
      fragment Category on Category {
        name
        plural
        uri
        path
        keywords
        id
      }
    `,
  });
};
